// language.js — Sprachwahl für App und Platzverwaltung (Profil und Konto-Menü nehmen denselben Weg wie das
// Sprachmenü der öffentlichen Seiten, public/js/i18n.js): Cookie vc_lang (im Host-Modus für alle Subdomains)
// + Konto-Einstellung, dann neu laden. Die Konto-Einstellung gewinnt serverseitig vor dem Cookie.
import { api } from './api.js';
import { cookieDomain } from './hosts.js';

/** {lang, manuell, aktiv:[{code,name}]} aus <script id="sprachen"> der Hülle; fehlt sie, null. */
export function readLanguages() {
  try { return JSON.parse(document.getElementById('sprachen').textContent); } catch { return null; }
}

export function chooseLanguage(code) {
  const secure = location.protocol === 'https:' ? '; secure' : '';
  const domain = cookieDomain();
  if (domain) document.cookie = 'vc_lang=; max-age=0; path=/';
  document.cookie = 'vc_lang=' + (code === 'auto' ? '' : code) + '; max-age=' + (code === 'auto' ? 0 : 31536000) + '; path=/; samesite=lax' + secure + domain;
  return api.put('/api/me', { preferences: { lang: code === 'auto' ? null : code } }).finally(() => location.reload());
}
